const URL_API = window._env_.REACT_APP_SIGNO_API_URL;
const URL_NOTIFICATIONS = URL_API + '/Notification';
export { URL_NOTIFICATIONS, URL_API };
